<template>
    <b-modal
        ref="ModalFiltroEmpresas"
        size="lg"
        no-close-on-esc
        no-close-on-backdrop
        scrollable
        :id="`modal-filtro-empresas-${name}`"
        title="Lista de empresas filtradas"
        v-drag
        @shown="openModal"
        >
        <el-alert
            v-show="infoFiltros"
            title="Cluster dinâmico"
            description="As empresas abaixo são referentes aos filtros configurados."
            type="info"
            show-icon
            @close="fecharInfoFiltros">
        </el-alert>
        <el-card class="box-card w-100">
            <div class="container-overflow-empresas" v-loading="loading" style="position:relative;"> 
                <el-input
                    placeholder="Filtrar Grupo/Empresa"
                    v-model="filtrarEmpresasPorNome"
                    size="small">
                </el-input>
                <el-button class="btn-expandir-todos" :title="`${!expandAll ? 'Expandir' : 'Recolher'} todos`" size="mini" circle @click.native="switchExpandAll" :icon="`${!expandAll ? 'el-icon-arrow-right' : 'el-icon-arrow-down'}`"></el-button>
                <el-table
                    v-if="isRerender"
                    :data="empresasFiltradas"
                    class="p-table"
                    row-key="id"
                    stripe
                    border
                    size="mini"
                    max-height="270"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    :default-expand-all="expandAll">
                        <el-table-column
                        prop="label"
                        align="left"
                        label="Grupo/Empresa">
                        </el-table-column>
                </el-table>
            </div>
            <el-pagination
                v-if="totalPaginacao > 0"
                class="text-center"
                background
                layout="prev, pager, next"
                @size-change="paginacaoSize"
                @current-change="paginacaoCurrent"
                :page-size="paginacao.perPage"
                :current-page.sync="paginacao.pageNumber"
                :total="totalPaginacao"
                :page-sizes="[5, 10, 25, 50, 75, 100]">
            </el-pagination>
        </el-card>


        <template #modal-footer="{ hide }">
            <div class="float-right">
                <el-button size="small" @click="hide()">Fechar</el-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { setTimeout } from 'timers';
export default {
    name: 'ModalFiltroEmpresas',
    props: {
        name: {
            type:String,
            required: true
        },
        id: {
            type: String,
            required: false
        },
        filtros: {
            type: Object,
            required: false
        }
    },
    data(){
        return {
            loading: false,
            filtrarEmpresasPorNome: '',
            expandAll: false,
            infoFiltros: true,
            isRerender: true,
            listas: {
                empresas: [],
                empresasPaginadas: []
            },
            paginacao: {
                pageNumber: 1,
                perPage: 6
            }
        }
    },
    watch: {
        filtrarEmpresasPorNome() {
            this.paginacao.pageNumber = 1;
        }
    },
    computed:{
        listaLength(){
            return this.listas.empresas.length
        },
        totalPaginacao() {
            let txt = this.filtrarEmpresasPorNome
            if (!txt || !txt.length) {
                return this.listaLength
            }
            return this.empresasPorNomeSemPaginacao().length
        },
        empresasFiltradas() {
            let txt = this.filtrarEmpresasPorNome
            if(!txt.length) {
                return this.listas.empresasPaginadas
            }

            let found = this.empresasPorNomeSemPaginacao()
            return this.paginacaoListas(
                found,
                this.paginacao.pageNumber,
                this.paginacao.perPage
            );
        }
    },
    methods: {
        limparListas() {
            this.listas.empresas = [];

            this.paginacao.pageNumber = 1
            this.paginacao.perPage = 6
        },
        empresasPorNomeSemPaginacao() {
            let txt = this.filtrarEmpresasPorNome
            return this.listas.empresas.filter((empresa) => {
                let label = empresa.label.toLowerCase();
                let children = empresa.children;
                let newChildren = [];

                if(children && children.length){
                    newChildren = children.filter((child) => {
                        let labelChild = child.label.toLowerCase();
                        return labelChild.includes(txt.toLocaleLowerCase())
                    })

                    if(newChildren.length) {
                        return true
                    }
                }

                return label.includes(txt.toLocaleLowerCase())
            })
        },
        formatarDadosFiltros() {
            const dadosEnvio = { }
            if(this.filtros && Object.keys(this.filtros).length){
                const joinIfLength = (obj,char) => { 
                    let isArray = Array.isArray(obj)
                    if(isArray){
                        if(obj.length > 0) {
                            return obj.join(char)
                        }else {
                            return null
                        }
                    }else if(obj && obj.length) {
                        return obj.toString()
                    }else {
                        return null
                    }
                }

                dadosEnvio.marca = joinIfLength(this.filtros.marca,',')
                dadosEnvio.tipoDeEstabelecimento = joinIfLength(this.filtros.tipoDeEstabelecimento,',')
                dadosEnvio.localEstabelecimento = joinIfLength(this.filtros.localEstabelecimento,',')
                dadosEnvio.codigoGrupo = joinIfLength(this.filtros.codigoGrupo,',')
                dadosEnvio.codigoLoja = this.filtros.grupo ? this.filtros.grupo.codigoLoja : this.filtros.codigoLoja
                dadosEnvio.regiaoBrasil = joinIfLength(this.filtros.regiaoBrasil,';')
                dadosEnvio.codigoEstado = joinIfLength(this.filtros.codigoEstado,';')
                dadosEnvio.codigoCidade = joinIfLength(this.filtros.codigoCidade,';')
                
            }
           
            if(this.id){
                dadosEnvio.ClusterId = this.id
            }

            // paginação por backend
            //dadosEnvio.Page = this.paginacao.pageNumber
            //dadosEnvio.PageSize = this.paginacao.perPage

            return dadosEnvio;
        },
        async requestEmpresas() {
            this.loading = true;
            let response = await this.axios({
                method: 'GET',
                params: this.formatarDadosFiltros(),
                url: this.$urls.CLUSTER_OBTER_EMPRESAS,
                headers:{
                    'Content-Type': 'application/json'				
                }
            })

            this.loading = false;

            if(response.status !== 200) {
                return;
            }

            this.listas.empresas = response.data;

            const perPage = this.paginacao.perPage;
            let totalPages = Math.max(1, Math.ceil(this.listas.empresas.length / perPage));
            if (this.paginacao.pageNumber > totalPages) {
                this.paginacao.pageNumber = totalPages;
            }

            this.listas.empresasPaginadas = this.paginacaoListas(
                this.listas.empresas,
                this.paginacao.pageNumber,
                perPage
            );
        },
        openModal() {
            this.limparListas();

            this.requestEmpresas();

            if(localStorage.getItem('infoFiltrosModal')) {
                this.infoFiltros = false
            }
        },
        paginacaoCurrent(val){
            this.paginacao.pageNumber = val;
            this.listas.empresasPaginadas = this.paginacaoListas(
                this.listas.empresas,
                val,
                this.paginacao.perPage
            );
        },
        paginacaoSize(val){
            this.paginacao.perPage = val
        },
        switchExpandAll() {
            this.isRerender = false;
            this.$nextTick(()=>{ 
                this.expandAll = !this.expandAll;
                this.isRerender = true;
            });
        },
        fecharInfoFiltros() {
            localStorage.setItem('infoFiltrosModal','visualizado')
            this.infoFiltros = false
        }
    }
}
</script>
<style lang="scss" scoped>
.btn-expandir-todos {
    position: absolute;
    left: 7px;
    top: 36px;
    z-index: 2;
}
</style>
<style>
    .container-overflow-empresas{
        max-height:310px; 
        height:310px; 
        overflow-y: auto;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track,
    .container-overflow-empresas::-webkit-scrollbar-track{
        box-shadow: inset 0 0 6px rgba(54, 54, 54, 0.3);
        background-color: #F5F5F5;
    }
    .el-table__body-wrapper::-webkit-scrollbar,
    .container-overflow-empresas::-webkit-scrollbar{
        width: 6px;
        background-color: #F5F5F5;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb,
    .container-overflow-empresas::-webkit-scrollbar-thumb{
        background-color: #5e5e5e;
    }
    .toggle-empresas {
        position: relative;
        top: 2px;
        margin: 0 9px 0 2px;
        cursor: pointer;
    }
    .display-contents{
        display: contents;
    }
    .table thead th,
    .table tbody td  {
        vertical-align: middle !important;
    }
    .toggle-empresas{
        margin: 4px;
        position: relative;
        top: 0;
    }
    .table-lista-empresas tr:nth-child(odd){
        background: #fff;
    }
    .table-lista-empresas tr:nth-child(even){
        background: #f4fafd;
    }
</style>
